import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import useRightCollapse from 'utils/hooks/sidebars/useRightCollapse';
import { useClosure } from 'utils/hooks';
import './index.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RightSidebarProps { }

export default function RightSidebar({ children }: React.PropsWithChildren<RightSidebarProps>) {
  const [collapsed, setCollapsed] = useRightCollapse();
  const collapseIcon: string = collapsed ? 'left_arrow' : 'right_arrow';

  return (
    <div className="right-sidebar">
      <button type="button" onClick={useClosure(setCollapsed, !collapsed)} className="btn btn-link right-sidebar-toggle">
        <Icon iconType={collapseIcon as IconType} />
        {!collapsed && <span className="ms-3">PAINEL DE CONTROLE</span>}
      </button>
      <div className={collapsed ? 'd-none' : ''}>
        {children}
      </div>
    </div>
  );
}
